<template>
    <div class="h-[40px]">
        <a :href="href"
            class="navigation-button bg-green-200 text-green-900 relative">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-width="0.25" d="M5.2 1.4l-3 4c-.13.173-.2.383-.2.6v14c0 1.656 1.342 3 3 3h14c1.656 0 3-1.344 3-3V6c0-.217-.071-.427-.2-.6l-3-4c-.189-.252-.486-.4-.8-.4H6c-.315 0-.612.148-.8.4Zm1.6 1.2L6 3h12l-.8-.4 3 4L20 6v14c0 .551-.449 1-1 1H5c-.553 0-1-.448-1-1V6l-.2.6 3-4Z"></path>
                <path stroke="currentColor" stroke-width="0.25" d="M3 7h18c.552 0 1-.448 1-1 0-.553-.448-1-1-1H3c-.553 0-1 .447-1 1 0 .552.447 1 1 1Z"></path>
                <path stroke="currentColor" stroke-width="0.25" d="M15 10c0 1.656-1.344 3-3 3 -1.658 0-3-1.343-3-3 0-.553-.448-1-1-1 -.553 0-1 .447-1 1 0 2.761 2.238 5 5 5 2.761 0 5-2.239 5-5 0-.553-.448-1-1-1 -.553 0-1 .447-1 1Z"></path>
            </svg>
            <div v-if="displayNumber > 0" class="absolute right-0 bottom-0 -mb-0.5 -mr-1">
                <div class="bg-green-900 flex items-center justify-center rounded-full w-5 h-5">
                    <span class="text-[11px] text-white font-semibold">
                        {{ displayNumber }}
                    </span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            href: {
                type: String,
                required: true,
            },
            basketItemsCount: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                displayNumber: this.basketItemsCount,
            }
        },

        // Pretty simple solution.
        // Listen for the global event that AddToBasket.vue emits when an item is added.
        // Then just add one to the counter.
        created() {
            Orbit.$on('global::basket:update', this.addOne)
        },

        methods: {
            addOne() {
                this.displayNumber++
            },
        },
    }
</script>
